import React, { useState, useEffect } from "react";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { format, parseISO } from "date-fns";
import { useSubheader } from "../../../_metronic/layout/_core/MetronicSubheader";
import axios from "axios";
import DataTable from "react-data-table-component";
import { jdsTableStyles } from "../../components/jds/tableStyles";
import SVG from "react-inlinesvg";

const FilterComponent = ({ filterText, onClear, onFilter }) => (
  <>
    <input
      id="search"
      type="text"
      placeholder="Filtro"
      className="form-control"
      style={{ width: "200px" }}
      value={filterText}
      onChange={onFilter}
    />
  </>
);

export function PlanGroups() {
  const columns = [
    {
      name: "Nome",
      selector: row => row.name,
      width: "70%"
    },
    {
      name: "Ações",
      selector: row => (
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <Link to={`/plan_groups/edit/${row.id}`}>
            <button
              type="button"
              className="btn btn-icon btn-primary"
              title="Editar"
            >
              <i className="flaticon-edit"></i>
            </button>
          </Link>
          <Link to={`/plan_groups/copy/${row.id}`}>
            <span className="btn btn-icon btn-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/copy.svg")}
                title="Duplicar"
              ></SVG>
            </span>
          </Link>
        </div>
      ),
      width: "20%",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
  ];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );

  const fetchPlanGroups = async page => {
    setLoading(true);
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/feature_groups/?page=${page}&per_page=${perPage}&filter=${filterText}`
    );

    setData(response.data.data.data);
    setTotalRows(response.data.data.totalItems);
    setLoading(false);
  };

  const handlePageChange = page => {
    fetchPlanGroups(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/feature_groups/?page=${page}&per_page=${newPerPage}&filter=${filterText}`
    );

    setData(response.data.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={e => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  useEffect(() => {
    fetchPlanGroups(1);
  }, []);

  useEffect(() => {
    fetchPlanGroups(1);
  }, [filterText]);

  return (
    <>
      <h1 className="azul-cabecalho">Grupo de planos</h1>
      <p className="subheader-text mb-10">
        Listagem de todos os grupos possíveis para planos
      </p>
      <Link to="/plan_groups/add">
        <button
          type="button"
          className="btn btn-icon btn-primary mb-10"
          style={{ width: "200px" }}
        >
          <i className="flaticon2-add"></i>&nbsp;&nbsp;Novo Grupo de Planos
        </button>
      </Link>

      <div className="row mb-10">
        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          perPage={perPage}
          paginationServer
          paginationTotalRows={totalRows}
          paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          customStyles={jdsTableStyles}
        />
      </div>
    </>
  );
}
